import { Grid } from "@mui/material";

import { loadLocalImage } from "../../../../utils";
import {
  SocialMediaContainer,
  SocialMediaLink,
  SocialMediaItem,
  SocialMediaPhoneLink,
  SocialMediaText,
} from "../styles/SocialMediaBoxStyles";

export const SOCIAL_MEDIA_ITEMS = [
  {
    link: "https://www.facebook.com/SulAmerica",
    icon: "facebook.png",
    title: "Facebook",
  },
  {
    link: "https://www.instagram.com/sulamerica/?hl=pt-br",
    icon: "instagram.png",
    title: "Instagram",
  },
  {
    link: "https://twitter.com/SulAmerica",
    icon: "twitter.png",
    title: "Twitter",
  },
  {
    link: "https://www.youtube.com/SulAmerica",
    icon: "youtube.png",
    title: "YouTube",
  },
  {
    link: "https://www.linkedin.com/company/sulamerica?originalSubdomain=br",
    icon: "likedin.png",
    title: "LinkedIn",
  },
] as const;

export function SocialMediaBox() {
  return (
    <SocialMediaContainer>
      <Grid container marginBottom={1}>
        <SocialMediaText>Siga-nos</SocialMediaText>
      </Grid>

      <Grid container>
        {SOCIAL_MEDIA_ITEMS.map(({ link, icon, title }) => (
          <SocialMediaItem size="grow" key={title}>
            <SocialMediaLink
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={title}
              title={title}
              $iconSrc={loadLocalImage(icon, "footer")}
            />
          </SocialMediaItem>
        ))}
      </Grid>

      <Grid container marginTop={1} alignItems="center">
        <SocialMediaText>
          <b style={{ marginRight: 10 }}>Dúvidas?</b>
        </SocialMediaText>

        <SocialMediaPhoneLink href="tel:30031159">
          3003-1159
        </SocialMediaPhoneLink>
      </Grid>
    </SocialMediaContainer>
  );
}

export default SocialMediaBox;